module.exports = __webpack_public_path__ + "987b84570ea69ee660455b8d5e91f5f1.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-100.woff2
// module id = 655
// module chunks = 0